import { ChackImageIsFile, CheckDataIfExit } from "src/helper/publicFunction";
import { setLoading } from "src/store/customizer/CustomizerSlice";
import { PostFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";

export const GetProjects =
  ({ callback }) =>
  async (dispatch, getState) => {
    try {
      const response = await PostFunction({
        data: {},
        Route: UrlApi.projects.get, // Use from UrlApi
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const ManageProjects =
  ({ callback, values, editMode }) =>
  async (dispatch, getState) => {
    try {

      dispatch(setLoading(true));
      const bodyFormData = new FormData();
      
      if (editMode) {
        bodyFormData.append("id", values.id);
      }
      
      if (values.title) bodyFormData.append("title", values.title.trim());
     
      if (values.full_desc) bodyFormData.append("full_desc", values.full_desc.trim());
  
      if (values.location) bodyFormData.append("location", values.location.trim());
      if (values.client) bodyFormData.append("client", values.client.trim());
      if (values.year) bodyFormData.append("year", values.year);
      if (values.slug) bodyFormData.append("slug", values.slug.trim());
      if (values.meta_key) bodyFormData.append("meta_key", values.meta_key.trim());
      if (values.meta_desc) bodyFormData.append("meta_desc", values.meta_desc.trim());
      if (values.page_title) bodyFormData.append("page_title", values.page_title.trim());
      
      // Handle image upload
      if (values.image) {
        if (values.image instanceof File) {
          bodyFormData.append("image", values.image);
        } else if (typeof values.image === "string") {
          // Existing image URL
          bodyFormData.append("image_url", values.image);
        }
      }


      // Use ternary to select correct URL
      const route = editMode ? UrlApi.projects.edit : UrlApi.projects.add;
      
      const response = await PostFunction({
        data: bodyFormData,
        Route: route,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch: dispatch,
      });
      
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const EditProjects =
  ({ callback, id, nameFailed, dataFailed }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      const formData = new FormData();
      formData.append("id", id);
      formData.append(nameFailed, dataFailed);
      
      const response = await PostFunction({
        data: formData,
        Route: UrlApi.projects.edit, // Use from UrlApi
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch,
      });
      
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const DeleteProjects =
  ({ callback, id }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      const response = await PostFunction({
        data: { idsprojects: id },
        Route: UrlApi.projects.delete, // Use from UrlApi
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };    